if (!customElements.get("sub-widget")) {
  customElements.define(
    "sub-widget",
    class SubWidget extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.handlePlanClick = this.handlePlanClick.bind(this);

        this.sellingPlanInput = this.querySelector('#selling_plan_hidden');
        this.planNameInput = this.querySelector('#plan_name_property');
        this.oneTimeDiscountInput = this.querySelector('#one_time_discount_cents_property');
        this.oneTimePriceInput = this.querySelector('#one_time_price_cents_property');
        this.oneTimeCompareAtInput = this.querySelector('#one_time_compare_at_cents_property');
        this.allPlans = this.querySelectorAll(".wt-subscription-widget__plans");
        this.quantityInput = this.getQuantityInput();

        this.addEventListeners();
        this.setInitialPlan();
      }

      setInitialPlan() {
        this.syncOneTimePreviewFromCheckedOption();

        let initialPlanSelected = null;
        if (this._preserveSelection) {
          if (this._preserveSelection.type === 'subscription' && this._preserveSelection.groupId) {
            initialPlanSelected = this.querySelector(`.wt-subscription-widget__plans[data-selling-plan-group="${this._preserveSelection.groupId}"]`);
          } else if (this._preserveSelection.type === 'one-time') {
            initialPlanSelected = this.querySelector('#single-purchase-plan');
          }
          this._preserveSelection = null;
        }

        if (!initialPlanSelected) {
          initialPlanSelected = this.querySelector('.wt-subscription-widget__plans--selected');
        }

        this.syncIntervalSelects(this.getCurrentVariantId());

        if (initialPlanSelected) {
          this.handlePlanClick(initialPlanSelected);
        }

        this.applyShowOnlyQty3OptionsMode();
      }

      reinit() {
        this.sellingPlanInput = this.querySelector('#selling_plan_hidden');
        this.planNameInput = this.querySelector('#plan_name_property');
        this.oneTimeDiscountInput = this.querySelector('#one_time_discount_cents_property');
        this.oneTimePriceInput = this.querySelector('#one_time_price_cents_property');
        this.oneTimeCompareAtInput = this.querySelector('#one_time_compare_at_cents_property');
        this.allPlans = this.querySelectorAll(".wt-subscription-widget__plans");
        this.quantityInput = this.getQuantityInput();
        this.allPlans.forEach((plan) => {
          plan.addEventListener("click", () => this.handlePlanClick(plan));
        });

        this.addSelectListeners();
        this.setInitialPlan();
      }

      addEventListeners() {
        this.allPlans.forEach((plan) => {
          plan.addEventListener("click", () => this.handlePlanClick(plan));
        });

        this.addSelectListeners();

        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
          const wrapper = this.closest('[data-section-id]');
          const sectionId = wrapper?.dataset?.sectionId;
          const originalSectionId = wrapper?.dataset?.originalSectionId;
          if (sectionId && e.data.sectionId !== sectionId && e.data.sectionId !== originalSectionId) return;

          const parsedHTML = e.data.html.querySelector(".wt-subscription-widget__container");
          if (!parsedHTML) return;

          const currentContainer = this.querySelector('.wt-subscription-widget__container');
          if (!currentContainer) return;

          currentContainer.innerHTML = parsedHTML.innerHTML;
          this.reinit();

          if (originalSectionId) {
            const sellingPlanInput = this.querySelector('input[name="selling_plan"]');
            if (sellingPlanInput) {
              sellingPlanInput.setAttribute('form', `product-form-${sectionId}`);
            }

            const planNameInput = this.querySelector('input[name="properties[Lieferplan]"]');
            if (planNameInput) {
              planNameInput.setAttribute('form', `product-form-${sectionId}`);
            }

            ['input[name="properties[_wt_one_time_discount_cents]"]', 'input[name="properties[_wt_one_time_price_cents]"]', 'input[name="properties[_wt_one_time_compare_at_cents]"]'].forEach((selector) => {
              const input = this.querySelector(selector);
              if (input) {
                input.setAttribute('form', `product-form-${sectionId}`);
              }
            });
          }
        });
      }

      addSelectListeners() {
        this.querySelectorAll(".wt-subscription-widget__plan-content__select").forEach((select) => {
          select.addEventListener("change", (e) => {
            e.stopPropagation();
            this.handleSelectChange(select);
          });
        });

        this.querySelectorAll(".wt-subscription-widget__plan-option__input").forEach((radio) => {
          radio.addEventListener("change", (e) => {
            e.stopPropagation();
            this.handleRadioChange(radio);
          });
        });
      }

      syncOneTimePreviewFromRadio(radio) {
        if (!radio || radio.dataset.quantityOnly !== 'true') return;

        const plan = this.querySelector('#single-purchase-plan');
        if (!plan) return;

        plan.dataset.quantity = radio.dataset.quantity || '1';
        plan.dataset.headerPrice = radio.dataset.headerPrice || radio.dataset.price || '';
        plan.dataset.headerCompareAtPrice = radio.dataset.headerCompareAtPrice || radio.dataset.compareAtPrice || '';
        plan.dataset.headerPriceRaw = radio.dataset.priceRaw || '';
        plan.dataset.headerCompareAtPriceRaw = radio.dataset.compareAtPriceRaw || '';
        plan.dataset.priceRaw = radio.dataset.priceRaw || '';
        plan.dataset.compareAtPriceRaw = radio.dataset.compareAtPriceRaw || '';
        plan.dataset.price = radio.dataset.price || '';
        plan.dataset.compareAtPrice = radio.dataset.compareAtPrice || '';
        plan.dataset.priceFormatted = radio.dataset.priceFormatted || '';
        plan.dataset.compareAtPriceFormatted = radio.dataset.compareAtPriceFormatted || '';

        this.updatePrice(
          plan,
          radio.dataset.compareAtPrice,
          radio.dataset.headerPrice || radio.dataset.price,
          radio.dataset.compareAtPriceRaw,
          radio.dataset.priceRaw,
          radio.dataset.price
        );
        this.updatePerPortion(plan, radio.dataset.perPortion || '');
        this.updateOneTimeSubtitle(plan, radio.dataset.planSubtitle);
      }

      updateOneTimeDiscountProperties(radio) {
        const discountCents = Number(radio?.dataset?.oneTimeDiscountCents || 0);
        if (!this.oneTimeDiscountInput || !this.oneTimePriceInput || !this.oneTimeCompareAtInput || discountCents <= 0) {
          this.clearOneTimeDiscountProperties();
          return;
        }

        this.oneTimeDiscountInput.value = String(discountCents);
        this.oneTimePriceInput.value = radio.dataset.priceRaw || '';
        this.oneTimeCompareAtInput.value = radio.dataset.compareAtPriceRaw || '';
      }

      clearOneTimeDiscountProperties() {
        if (this.oneTimeDiscountInput) this.oneTimeDiscountInput.value = '';
        if (this.oneTimePriceInput) this.oneTimePriceInput.value = '';
        if (this.oneTimeCompareAtInput) this.oneTimeCompareAtInput.value = '';
      }

      updateOneTimeSubtitle(plan, variantTitle) {
        const subtitle = plan.querySelector('[data-delivery-subtitle]');
        if (!subtitle || !variantTitle) return;
        const suffix = subtitle.dataset.subtitleSuffix;
        subtitle.textContent = suffix ? `${variantTitle}, ${suffix}` : variantTitle;
      }

      syncOneTimePreviewFromCheckedOption() {
        const checkedOneTimeOption = this.querySelector('[data-one-time-options] .wt-subscription-widget__plan-option__input:checked');
        if (!checkedOneTimeOption) return;

        this.syncOneTimePreviewFromRadio(checkedOneTimeOption);
      }

      syncOneTimePreviewForVariant(variantId) {
        const oneTimeOptions = Array.from(this.querySelectorAll('[data-one-time-options] .wt-subscription-widget__plan-option__input'));
        if (oneTimeOptions.length === 0) return;

        const visibleOneTimeOptions = oneTimeOptions.filter((radio) => this.isOptionVisible(radio) && !radio.disabled);
        const matchingOption = visibleOneTimeOptions.find((radio) => {
          return radio.dataset.variantId === String(variantId);
        }) || visibleOneTimeOptions[0] || oneTimeOptions[0];

        if (!matchingOption) return;

        matchingOption.checked = true;
        this.syncOneTimePreviewFromRadio(matchingOption);
      }

      isShowOnlyQty3ModeEnabled() {
        const widget = this.closest('.wt-subscription-widget');
        if (!widget) return false;
        return widget.dataset.showOnlyQty3Options === 'true';
      }

      syncIntervalSelects(variantId) {
        const selects = this.querySelectorAll('[data-interval-select]');
        if (!selects.length) return;

        selects.forEach((select) => {
          const isActive = String(select.dataset.variantId) === String(variantId);
          select.hidden = !isActive;
          select.disabled = !isActive;
          if (!isActive) return;

          // Quantity change resets the interval to the default configured for that variant
          const defaultPlanId = select.dataset.defaultPlanId;
          if (defaultPlanId && select.value !== defaultPlanId) {
            select.value = defaultPlanId;
          }
        });
      }

      isOptionVisible(radio) {
        const label = radio.closest('.wt-subscription-widget__plan-option');
        return !label || !label.hidden;
      }

      applyShowOnlyQty3OptionsMode() {
        if (!this.isShowOnlyQty3ModeEnabled()) return;

        const visibleQty3Radios = [];
        const optionGroups = Array.from(this.querySelectorAll('[data-subscription-options], [data-one-time-options]'));

        optionGroups.forEach((group) => {
          const radios = Array.from(group.querySelectorAll('.wt-subscription-widget__plan-option__input'));
          if (radios.length === 0) return;

          const preferredRadioInGroup = radios[1] || radios[0];

          radios.forEach((radio) => {
            const label = radio.closest('.wt-subscription-widget__plan-option');
            const keepVisible = radio === preferredRadioInGroup;

            if (!Object.prototype.hasOwnProperty.call(radio.dataset, 'originalDisabled')) {
              radio.dataset.originalDisabled = radio.disabled ? 'true' : 'false';
            }

            if (label) {
              label.hidden = !keepVisible;
            }

            radio.disabled = !keepVisible || radio.dataset.originalDisabled === 'true';

            if (!keepVisible && radio.checked) {
              radio.checked = false;
            }
          });

          if (preferredRadioInGroup) {
            visibleQty3Radios.push(preferredRadioInGroup);
          }
        });

        if (visibleQty3Radios.length === 0) return;

        const preferredRadio = visibleQty3Radios.find((radio) => radio.dataset.quantityOnly !== 'true' && !radio.disabled)
          || visibleQty3Radios.find((radio) => radio.dataset.quantityOnly !== 'true')
          || visibleQty3Radios.find((radio) => !radio.disabled)
          || visibleQty3Radios[0];
        if (!preferredRadio) return;

        preferredRadio.checked = true;
        this.handleRadioChange(preferredRadio);
      }

      handleSelectChange(select) {
        const plan = select.closest(".wt-subscription-widget__plans");
        if (!plan || !plan.classList.contains("wt-subscription-widget__plans--selected")) return;

        const selectedOption = select.options[select.selectedIndex];
        if (!selectedOption) return;

        this.sellingPlanInput.value = selectedOption.value;
        this.updatePlanNameProperty(selectedOption.dataset.planName);
        this.updateQuantity(selectedOption.dataset.quantity);

        const compareAtPrice = selectedOption.dataset.compareAtPrice;
        const price = selectedOption.dataset.price;
        this.updatePrice(
          plan,
          compareAtPrice,
          selectedOption.dataset.headerPrice || price,
          selectedOption.dataset.compareAtPriceRaw,
          selectedOption.dataset.priceRaw,
          price
        );
        // Subtitle and description belong to the variant, so an interval-only select leaves them alone
        if (selectedOption.dataset.planSubtitle) {
          this.updatePlanSubtitle(plan, selectedOption.dataset.planSubtitle);
        }
        if (selectedOption.dataset.description !== undefined) {
          this.updatePlanDescription(plan, selectedOption.dataset.description);
        }
        this.updateSavingsBadge(plan, selectedOption.dataset.savings);
        this.updatePerPortion(plan, selectedOption.dataset.perPortion); 
        this.updateURLParamsIfEnabled(selectedOption.value);
        const priceData = {
          price: selectedOption.dataset.priceFormatted,
          compareAtPrice: selectedOption.dataset.compareAtPriceFormatted,
          priceRaw: Number(selectedOption.dataset.priceRaw),
          compareAtPriceRaw: Number(selectedOption.dataset.compareAtPriceRaw),
          unitPrice: selectedOption.dataset.unitPrice,
        };
        this.updatePriceBlock(priceData);
        this.updateStickyPriceBlock(priceData);
      }

      handleRadioChange(radio) {
        // Drive the theme's real variant picker (updates gallery, main price,
        // availability). We still update the widget's own state below so the
        // selection reflects immediately even if the theme re-render is delayed.
        this.selectVariant(radio);

        if (radio.dataset.quantityOnly === 'true') {
          this.syncOneTimePreviewFromRadio(radio);
        } else {
          this.syncOneTimePreviewForVariant(radio.dataset.variantId);
        }

        if (radio.dataset.quantityOnly === 'true') {
          const plan = this.querySelector('#single-purchase-plan');
          if (!plan) return;

          this.allPlans.forEach((item) => item.classList.remove('wt-subscription-widget__plans--selected'));
          plan.classList.add('wt-subscription-widget__plans--selected');
          this.updateOneTimeState(plan);
          this.sellingPlanInput.value = '';
          this.updatePlanNameProperty('');
          this.updateOneTimeDiscountProperties(radio);
          this.updateVariantId(radio.dataset.variantId);
          this.updateQuantity(radio.dataset.quantity);
          this.updatePrice(
            plan,
            radio.dataset.compareAtPrice,
            radio.dataset.headerPrice || radio.dataset.price,
            radio.dataset.compareAtPriceRaw,
            radio.dataset.priceRaw,
            radio.dataset.price
          );
          this.updateSavingsBadge(plan, '');
          this.updatePerPortion(plan, radio.dataset.perPortion || '');
          this.syncIntervalSelects(radio.dataset.variantId);
          this.updateURLParamsIfEnabled(null);

          const priceData = {
            price: radio.dataset.priceFormatted,
            compareAtPrice: radio.dataset.compareAtPriceFormatted,
            priceRaw: Number(radio.dataset.priceRaw),
            compareAtPriceRaw: Number(radio.dataset.compareAtPriceRaw),
            unitPrice: radio.dataset.unitPrice,
          };
          this.updatePriceBlock(priceData);
          this.updateStickyPriceBlock(priceData);
          return;
        }

        const groupId = radio.name.replace('plan_options_', '');
        const plan = this.querySelector(`.wt-subscription-widget__plans[data-selling-plan-group="${groupId}"]`);
        if (!plan) return;
        this.allPlans.forEach((item) => item.classList.remove('wt-subscription-widget__plans--selected'));
        plan.classList.add('wt-subscription-widget__plans--selected');
        this.updateOneTimeState(plan);
        this.sellingPlanInput.value = radio.value;
        this.updatePlanNameProperty(radio.dataset.planName);
        this.clearOneTimeDiscountProperties();
        this.updateVariantId(radio.dataset.variantId);
        this.updateQuantity(radio.dataset.quantity);
        const compareAtPrice = radio.dataset.compareAtPrice;
        const price = radio.dataset.price;
        this.updatePrice(
          plan,
          compareAtPrice,
          radio.dataset.headerPrice || price,
          radio.dataset.compareAtPriceRaw,
          radio.dataset.priceRaw,
          price
        );
        this.updatePlanSubtitle(plan, radio.dataset.planSubtitle || radio.dataset.planName);
        this.updatePlanDescription(plan, radio.dataset.description);
        this.updateSavingsBadge(plan, radio.dataset.savings);
        this.updatePerPortion(plan, radio.dataset.perPortion);
        this.syncIntervalSelects(radio.dataset.variantId);
        this.updateURLParamsIfEnabled(radio.value);
        const priceData = {
          price: radio.dataset.priceFormatted,
          compareAtPrice: radio.dataset.compareAtPriceFormatted,
          priceRaw: Number(radio.dataset.priceRaw),
          compareAtPriceRaw: Number(radio.dataset.compareAtPriceRaw),
          unitPrice: radio.dataset.unitPrice,
        };
        this.updatePriceBlock(priceData);
        this.updateStickyPriceBlock(priceData);
      }

      handlePlanClick(plan) {
        this.allPlans.forEach((item) => {
          item.classList.remove("wt-subscription-widget__plans--selected");
        });
        plan.classList.add("wt-subscription-widget__plans--selected");
        this.updateOneTimeState(plan);
        this.syncQuantitySelection(plan);

        const groupId = plan.dataset.sellingPlanGroup;
        const checkedRadio = groupId
          ? this.querySelector(`input[name="plan_options_${groupId}"]:checked`)
          : this.querySelector('[data-one-time-options] .wt-subscription-widget__plan-option__input:checked');

        if (checkedRadio) {
          if (checkedRadio.dataset.quantityOnly === 'true') {
            this.sellingPlanInput.value = '';
            this.updatePlanNameProperty('');
            this.updateOneTimeDiscountProperties(checkedRadio);
          } else {
            const _ais = this.querySelector('[data-interval-select]:not([hidden])');
            this.sellingPlanInput.value = (_ais && _ais.value) ? _ais.value : checkedRadio.value;
            const _pn = _ais ? (_ais.options[_ais.selectedIndex]?.dataset.planName || checkedRadio.dataset.planName) : checkedRadio.dataset.planName;
            this.updatePlanNameProperty(_pn);
            this.clearOneTimeDiscountProperties();
          }
          this.updateQuantity(checkedRadio.dataset.quantity);
          const compareAtPrice = checkedRadio.dataset.compareAtPrice;
          const price = checkedRadio.dataset.price;
          this.updatePrice(
            plan,
            compareAtPrice,
            checkedRadio.dataset.headerPrice || price,
            checkedRadio.dataset.compareAtPriceRaw,
            checkedRadio.dataset.priceRaw,
            price
          );
          if (checkedRadio.dataset.quantityOnly === 'true') {
            this.updateSavingsBadge(plan, '');
            this.updatePerPortion(plan, checkedRadio.dataset.perPortion || '');
          } else {
            this.updatePlanSubtitle(plan, checkedRadio.dataset.planSubtitle || checkedRadio.dataset.planName);
            this.updatePlanDescription(plan, checkedRadio.dataset.description);
            this.updateSavingsBadge(plan, checkedRadio.dataset.savings);
            this.updatePerPortion(plan, checkedRadio.dataset.perPortion);
          }
          const priceData = {
            price: checkedRadio.dataset.priceFormatted,
            compareAtPrice: checkedRadio.dataset.compareAtPriceFormatted,
            priceRaw: Number(checkedRadio.dataset.priceRaw),
            compareAtPriceRaw: Number(checkedRadio.dataset.compareAtPriceRaw),
            unitPrice: checkedRadio.dataset.unitPrice,
          };
          this.updatePriceBlock(priceData);
          this.updateStickyPriceBlock(priceData);
          this.updateURLParamsIfEnabled(checkedRadio.dataset.quantityOnly === 'true' ? null : checkedRadio.value);
        } else if (plan.dataset.sellingPlanId) {
          this.sellingPlanInput.value = plan.dataset.sellingPlanId;
          this.updatePlanNameProperty(plan.dataset.planName);
          this.clearOneTimeDiscountProperties();
          this.updateQuantity(plan.dataset.quantity);
          this.updatePrice(
            plan,
            plan.dataset.compareAtPrice,
            plan.dataset.headerPrice || plan.dataset.price,
            plan.dataset.headerCompareAtPriceRaw || plan.dataset.compareAtPriceRaw,
            plan.dataset.headerPriceRaw || plan.dataset.priceRaw,
            plan.dataset.price
          );
          this.updatePlanSubtitle(plan, plan.dataset.planName);
          this.updatePlanDescription(plan, plan.dataset.description);
          this.updateSavingsBadge(plan, plan.dataset.savings);
          this.updatePerPortion(plan, plan.dataset.perPortion);
          const priceData = {
            price: plan.dataset.priceFormatted,
            compareAtPrice: plan.dataset.compareAtPriceFormatted,
            priceRaw: Number(plan.dataset.priceRaw),
            compareAtPriceRaw: Number(plan.dataset.compareAtPriceRaw),
            unitPrice: plan.dataset.unitPrice,
          };
          this.updatePriceBlock(priceData);
          this.updateStickyPriceBlock(priceData);
          this.updateURLParamsIfEnabled(plan.dataset.sellingPlanId);
        } else {
          const _ais = this.querySelector('[data-interval-select]:not([hidden])');
          this.sellingPlanInput.value = (_ais && _ais.value) ? _ais.value : '';
          this.updatePlanNameProperty(_ais ? (_ais.options[_ais.selectedIndex]?.dataset.planName || '') : '');
          this.clearOneTimeDiscountProperties();
          this.updateQuantity(plan.dataset.quantity || 1);
          const priceData = {
            price: plan.dataset.priceFormatted,
            compareAtPrice: plan.dataset.compareAtPriceFormatted,
            priceRaw: Number(plan.dataset.priceRaw),
            compareAtPriceRaw: Number(plan.dataset.compareAtPriceRaw),
            unitPrice: plan.dataset.unitPrice,
          };
          this.updatePriceBlock(priceData);
          this.updateStickyPriceBlock(priceData);
          this.updateURLParamsIfEnabled(null);
        }

      }

      updatePrice(plan, compareAtPrice, price, compareAtPriceRaw, priceRaw, totalPrice) {
        const priceElement = plan.querySelector('.wt-subscription-widget__plan-header__price-regular');
        const compareAtPriceElement = plan.querySelector('.wt-subscription-widget__plan-header__price-sale');
        const totalActualElement = plan.querySelector('[data-price-total-actual]');
        const totalRow = plan.querySelector('.wt-subscription-widget__plan-header__price-row--total');

        const compareRawNum = Number(compareAtPriceRaw);
        const priceRawNum = Number(priceRaw);
        const hasRawValues = Number.isFinite(compareRawNum) && Number.isFinite(priceRawNum);
        const hasDiscount = hasRawValues
          ? compareRawNum > priceRawNum
          : Boolean(compareAtPrice && price && String(compareAtPrice).trim() !== String(price).trim());

        if (totalRow) {
          totalRow.hidden = !hasDiscount;
        }
        if (compareAtPriceElement) {
          if (hasDiscount) {
            compareAtPriceElement.innerHTML = compareAtPrice;
            compareAtPriceElement.hidden = false;
          } else {
            compareAtPriceElement.innerHTML = '';
            compareAtPriceElement.hidden = true;
          }
        }
        if (totalActualElement && totalPrice) {
          totalActualElement.innerHTML = totalPrice;
        }
        if (priceElement) {
          if (hasDiscount) {
            priceElement.classList.add('wt-subscription-widget__plan-header__price-regular--sale');
          } else {
            priceElement.classList.remove('wt-subscription-widget__plan-header__price-regular--sale');
          }
          if (price) {
            priceElement.innerHTML = price;
          }
        }
      }

      updatePlanNameProperty(name) {
        if (!this.planNameInput) return;
        this.planNameInput.value = name || '';
      }

      updatePlanSubtitle(plan, planName) {
        const subtitle = plan.querySelector('[data-delivery-subtitle]');
        if (subtitle && planName) subtitle.textContent = planName;
      }

      updatePlanDescription(plan, descriptionHtml) {
        const description = plan.querySelector('[data-plan-description]');
        const content = plan.querySelector('.wt-subscription-widget__plan-content');
        if (!description || !content) return;

        const normalizedDescription = (descriptionHtml || '').trim();
        description.innerHTML = normalizedDescription;
        content.hidden = !normalizedDescription;
      }

      getProductForm() {
        if (this.sellingPlanInput?.form) return this.sellingPlanInput.form;

        const wrapper = this.closest('[data-section-id]');
        const sectionId = wrapper?.dataset?.sectionId;
        if (!sectionId) return null;

        return document.getElementById(`product-form-${sectionId}`);
      }

      getQuantityInput() {
        const form = this.getProductForm();
        if (!form) return null;

        let quantityInput = form.querySelector('input[name="quantity"]');
        if (quantityInput) return quantityInput;

        quantityInput = document.createElement('input');
        quantityInput.type = 'hidden';
        quantityInput.name = 'quantity';
        quantityInput.value = '1';
        form.appendChild(quantityInput);
        return quantityInput;
      }

      updateQuantity(quantity) {
        const normalizedQuantity = Math.max(1, Number.parseInt(quantity, 10) || 1);
        this.quantityInput = this.getQuantityInput();
        if (!this.quantityInput) return;

        this.quantityInput.value = String(normalizedQuantity);
        this.quantityInput.setAttribute('value', String(normalizedQuantity));
        this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      getCurrentQuantity() {
        this.quantityInput = this.getQuantityInput();
        return Math.max(1, Number.parseInt(this.quantityInput?.value, 10) || 1);
      }

      getVariantIdInput() {
        const form = this.getProductForm();
        if (!form) return null;
        return form.querySelector('input[name="id"]');
      }

      getCurrentVariantId() {
        const idInput = this.getVariantIdInput();
        return idInput ? idInput.value : null;
      }

      updateVariantId(variantId) {
        if (!variantId) return;
        const idInput = this.getVariantIdInput();
        if (!idInput) return;

        idInput.value = String(variantId);
        idInput.setAttribute('value', String(variantId));
        idInput.dispatchEvent(new Event('input', { bubbles: true }));
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      getVariantOptionsElement() {
        const wrapper = this.closest('[data-section-id]');
        const sectionId = wrapper?.dataset?.sectionId;
        const originalSectionId = wrapper?.dataset?.originalSectionId;

        const tryFind = (selector) => {
          try {
            return document.querySelector(selector);
          } catch (e) {
            return null;
          }
        };

        if (sectionId) {
          const scoped = tryFind(`variant-options[data-section="${sectionId}"]`)
            || tryFind(`#shopify-section-${sectionId} variant-options`);
          if (scoped) return scoped;
        }
        if (originalSectionId) {
          const scoped = tryFind(`variant-options[data-section="${originalSectionId}"]`);
          if (scoped) return scoped;
        }
        return document.querySelector('variant-options');
      }

      selectVariant(radio) {
        const variantId = radio.dataset.variantId;
        if (!variantId) return false;

        const variantOptions = this.getVariantOptionsElement();
        if (!variantOptions) {
          // No theme variant picker on the page: drive the form input directly.
          this.updateVariantId(variantId);
          return false;
        }

        if (String(this.getCurrentVariantId()) === String(variantId)) {
          return false;
        }

        // Remember the active plan card so it survives the theme's re-render.
        const selectedCard = this.querySelector('.wt-subscription-widget__plans--selected');
        if (selectedCard) {
          this._preserveSelection = selectedCard.dataset.sellingPlanGroup
            ? { type: 'subscription', groupId: selectedCard.dataset.sellingPlanGroup }
            : { type: 'one-time' };
        }

        const optionValues = [radio.dataset.option1, radio.dataset.option2, radio.dataset.option3];
        const fieldsets = variantOptions.querySelectorAll('.wt-product__option');
        let changed = false;
        let lastChangedInput = null;

        fieldsets.forEach((fieldset, index) => {
          const targetValue = optionValues[index];
          if (targetValue == null || targetValue === '') return;

          const inputs = fieldset.querySelectorAll('input[type="radio"]');
          inputs.forEach((input) => {
            if (input.value === targetValue) {
              if (!input.checked) {
                input.checked = true;
                changed = true;
              }
              lastChangedInput = input;
            }
          });
        });

        if (changed && lastChangedInput) {
          lastChangedInput.dispatchEvent(new Event('change', { bubbles: true }));
          // The theme handles variant resolution and re-renders this widget.
          return true;
        }

        this._preserveSelection = null;
        return false;
      }

      syncQuantitySelection(plan) {
        const currentVariantId = this.getCurrentVariantId();
        this.syncOneTimePreviewForVariant(currentVariantId);

        if (plan.id === 'single-purchase-plan' || plan.classList.contains('wt-subscription-widget__plans--one-time')) {
          const oneTimeOptions = this.querySelectorAll('[data-one-time-options] .wt-subscription-widget__plan-option__input');
          const visibleOneTimeOptions = Array.from(oneTimeOptions).filter((radio) => this.isOptionVisible(radio) && !radio.disabled);
          const matchingOneTimeOption = visibleOneTimeOptions.find((radio) => {
            return radio.dataset.variantId === String(currentVariantId);
          });

          if (matchingOneTimeOption) {
            matchingOneTimeOption.checked = true;
          } else if (visibleOneTimeOptions.length > 0) {
            visibleOneTimeOptions[0].checked = true;
          }

          return;
        }

        const groupId = plan.dataset.sellingPlanGroup;
        if (!groupId) return;

        const subscriptionOptions = this.querySelectorAll(`input[name="plan_options_${groupId}"]`);
        const visibleSubscriptionOptions = Array.from(subscriptionOptions).filter((radio) => this.isOptionVisible(radio) && !radio.disabled);
        const matchingSubscriptionOption = visibleSubscriptionOptions.find((radio) => {
          return radio.dataset.variantId === String(currentVariantId);
        });

        if (matchingSubscriptionOption) {
          matchingSubscriptionOption.checked = true;
        } else if (visibleSubscriptionOptions.length > 0) {
          visibleSubscriptionOptions[0].checked = true;
        }
      }

      updateOneTimeState(plan) {
        const widget = this.closest('.wt-subscription-widget');
        if (!widget) return;

        const oneTimeSelected = plan.id === 'single-purchase-plan' || plan.classList.contains('wt-subscription-widget__plans--one-time');
        widget.classList.toggle('wt-subscription-widget--one-time-selected', oneTimeSelected);
      }

      updateSavingsBadge(plan, savings) {
        const badge = plan.querySelector('[data-savings-badge]');
        if (!badge) return;
        if (savings) {
          const prefix = badge.dataset.savingsPrefix || '';
          if (prefix) {
            const noSpace = '-–—+~ '.includes(prefix.slice(-1));
            badge.textContent = noSpace ? `${prefix}${savings}` : `${prefix} ${savings}`;
          } else {
            badge.textContent = savings;
          }
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      }

      updatePerPortion(plan, perPortion) {
        const el = plan.querySelector('[data-per-portion]');
        if (!el) return;

        if (!perPortion) {
          el.textContent = '';
          el.hidden = true;
          return;
        }

        const label = el.dataset.portionLabel || '';
        el.textContent = label ? `${perPortion} ${label}` : perPortion;
        el.hidden = false;
      }

      updatePriceBlock({ price, compareAtPrice, priceRaw, compareAtPriceRaw, unitPrice }) {
        const sectionId = this.closest('[data-section-id]')?.dataset?.sectionId;
        if (!sectionId) return;

        const priceBlock = document.getElementById(`price-${sectionId}`);
        if (!priceBlock) return;

        const priceContainer = priceBlock.querySelector('.price');
        if (!priceContainer) return;

        if (!price) return;

        if (unitPrice) {
          const unitPriceEl = priceContainer.querySelector('.unit-price .price-item--last');
          if (unitPriceEl) unitPriceEl.textContent = unitPrice;
        }

        const isOnSale = compareAtPriceRaw > priceRaw;

        priceContainer.classList.toggle('price--on-sale', isOnSale);

        const regularPriceEl = priceContainer.querySelector('.price__regular .wt-product__price__final');
        if (regularPriceEl) regularPriceEl.innerHTML = price;

        const salePriceEl = priceContainer.querySelector('.price__sale .wt-product__price__final');
        if (salePriceEl) salePriceEl.innerHTML = price;

        const saleDiv = priceContainer.querySelector('.price__sale');
        if (saleDiv) {
          saleDiv.classList.toggle('visible', isOnSale);
          saleDiv.classList.remove('visible-main-product');
        }

        const compareEl = priceContainer.querySelector('.wt-product__price__compare');
        if (compareEl) {
          compareEl.innerHTML = isOnSale ? compareAtPrice : '';
          compareEl.classList.toggle('hidden', !isOnSale);
        }

        let percentEl = priceContainer.querySelector('.price-item--percent');
        if (isOnSale) {
          const percent = Math.round((compareAtPriceRaw - priceRaw) / compareAtPriceRaw * 100);
          if (percentEl) {
            percentEl.textContent = `-${percent}%`;
          } else {
            const wrapper = priceContainer.querySelector('.price__sale__details-wrapper');
            if (wrapper) {
              percentEl = document.createElement('span');
              percentEl.className = 'price-item--percent';
              percentEl.textContent = `-${percent}%`;
              wrapper.appendChild(percentEl);
            }
          }
        } else if (percentEl) {
          percentEl.remove();
        }
      }

      updateStickyPriceBlock({ price, compareAtPrice, priceRaw, compareAtPriceRaw, unitPrice }) {
        const sectionId = this.closest('[data-section-id]')?.dataset?.sectionId;
        if (!sectionId) return;

        const stickyPriceBlock = document.getElementById(`sticky-price-${sectionId}`);
        if (!stickyPriceBlock) return;

        const priceContainer = stickyPriceBlock.querySelector('.price');
        if (!priceContainer) return;

        if (!price) return;

        if (unitPrice) {
          const unitPriceEl = priceContainer.querySelector('.unit-price .price-item--last');
          if (unitPriceEl) unitPriceEl.textContent = unitPrice;
        }

        const isOnSale = compareAtPriceRaw > priceRaw;

        priceContainer.classList.toggle('price--on-sale', isOnSale);

        const regularPriceEl = priceContainer.querySelector('.price__regular .wt-product__price__final');
        if (regularPriceEl) regularPriceEl.innerHTML = price;

        const salePriceEl = priceContainer.querySelector('.price__sale .wt-product__price__final');
        if (salePriceEl) salePriceEl.innerHTML = price;

        const saleDiv = priceContainer.querySelector('.price__sale');
        if (saleDiv) {
          saleDiv.classList.toggle('visible', isOnSale);
          saleDiv.classList.remove('visible-main-product');
        }

        const compareEl = priceContainer.querySelector('.wt-product__price__compare');
        if (compareEl) {
          compareEl.innerHTML = isOnSale ? compareAtPrice : '';
          compareEl.classList.toggle('hidden', !isOnSale);
        }

        let percentEl = priceContainer.querySelector('.price-item--percent');
        if (isOnSale) {
          const percent = Math.round((compareAtPriceRaw - priceRaw) / compareAtPriceRaw * 100);
          if (percentEl) {
            percentEl.textContent = `-${percent}%`;
          } else {
            const wrapper = priceContainer.querySelector('.price__sale__details-wrapper');
            if (wrapper) {
              percentEl = document.createElement('span');
              percentEl.className = 'price-item--percent';
              percentEl.textContent = `-${percent}%`;
              wrapper.appendChild(percentEl);
            }
          }
        } else if (percentEl) {
          percentEl.remove();
        }
      }

      updateURLParamsIfEnabled(planId) {
        const wrapper = this.closest('[data-update-url-on-plan-change]');
        if (wrapper?.dataset.updateUrlOnPlanChange === 'false') return;

        const urlParams = new URLSearchParams(window.location.search);
        if (planId) {
          urlParams.set("selling_plan", planId);
        } else {
          urlParams.delete("selling_plan");
        }
        window.history.pushState({}, "", `${window.location.pathname}?${urlParams.toString()}`);
      }

      disconnectedCallback() {
        if (typeof this.unsubscribeVariantChange === 'function') {
          this.unsubscribeVariantChange();
        }
      }
    }
  );
}
